module.exports = __webpack_public_path__ + "img/whatsapp-icon.0fc1b8b.svg";